import { Stack, Title } from '@mantine/core'
import { FaqTab } from '@/pages/website/index'

export default function FaqsPage() {
  return (
    <Stack>
      <Title order={2}>Асуулт хариулт</Title>
      <FaqTab />
    </Stack>
  )
}
